import React, {
    useEffect,
    useState
} from "react";

import { Outlet } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import politicianData from "./data/politicianData";
import { usePublicSite } from "./context/PublicSiteContext";


const Layout = () => {

     const { siteData, loading, error } = usePublicSite();

    const [menuOpen, setMenuOpen] =
        useState(false);


    const [darkMode, setDarkMode] =
        useState(() => {

            try {

                return (
                    localStorage.getItem(
                        "akindele-theme"
                    ) === "dark"
                );

            } catch {

                return false;

            }

        });


    /*
    |--------------------------------------------------------------------------
    | Theme
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        document.documentElement.style.colorScheme =
            darkMode
                ? "dark"
                : "light";


        try {

            localStorage.setItem(
                "akindele-theme",
                darkMode
                    ? "dark"
                    : "light"
            );

        } catch {}

    }, [darkMode]);


    /*
    |--------------------------------------------------------------------------
    | Close mobile menu whenever route changes
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        setMenuOpen(false);

    }, [window.location.pathname]);


    return (
        <div
            className={`politician-home ${
                darkMode
                    ? "dark-mode"
                    : "light-mode"
            }`}
        >

            <a
                className="skip-link"
                href="#main-content"
            >
                Skip to main content
            </a>


            <Header
                data={siteData}
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
                darkMode={darkMode}
                setDarkMode={setDarkMode}
            />


            <main id="main-content">

                <Outlet />

            </main>


            <Footer
                data={siteData}
            />

        </div>
    );
};


export default Layout;

